import moment from "moment/moment";
import { useState, useEffect, useReducer } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
// import DataTable from "datatables.net";
import { MainArea, MainAreaHeader, MainAreaBody } from "../../../layout/MainArea";
import { requestToServer } from "../../../utils/appUtils";
// import { reducerModalWindow } from "./ModalMfS";
import { reducerModalWindow, ModalMfS } from "./ModalMfS";
import { GetConnERA, GetConnPYV, PostConnERA, POSTConnPYV, PostControlMC } from "../../../../api";
import { Modal } from 'react-bootstrap';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';


function PUVSRKStations(props) {
    clearInterval(window.timer)
    const token = localStorage.getItem('token')
    const [serverData, setServerData] = useState(null);
    const { showErrorPage, messageBox } = useOutletContext();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(3);
    const [date, setDate] = useState();
    const [loadingStatus, setLoadingStatus] = useState(true)
    const [paramsModalWindow, dispatchModalWindow] = useReducer(reducerModalWindow, { show: false});
    const [activeIndex, setActiveIndex] = useState(0)
    const [showParrot, setShowParrot] = useState(false)
    const [inputParrotT, setInputParrotT] = useState()
    const [inputParrotS, setInputParrotS] = useState()

    const [currentPage, setCurrentPage] = useState(1);
    const [arrTable, setArrTable] = useState([])



    let services = [
        { id: 0, name: "Доступность ККС", status: status, date: date, href: 'msdata' },
    ];

    const handleModal = (id) => {
        dispatchModalWindow({ type: 'def', id: id });
    };

const handleClick = (event) => {
    if (loading) return;
   event && event.preventDefault();
   event && event.target.blur();
    //    refreshData();
    setLoading(true);
    GetConnPYV(token).then((e) => {
      setArrTable([{value: e.data.port_command, name: "Телекодовый"}, { value: e.data.port_status, name: "Статусный"}])
      setServerData(true)
    })
    setDate(Date.now())
    setTimeout(() => {
      setLoading(false);
    }, 650);
}

    useEffect(() => {
      handleClick()
      
    }, [])

    let styleCard = {};
    let classCard = "card h-100";
    if (props.dashboard === false) {
        styleCard = { minHeight: "var(--clientheight)" };
        classCard = "card border-0";
    }

    const handleCloseParrot = (event) => {
        setShowParrot(false);
        setInputParrotS();
        setInputParrotT();

    }
    const handleBlur = () => {
        // При потере фокуса устанавливаем 0 если поле пустое
        if (inputParrotT === '') {
            setInputParrotT();
        }
        if (inputParrotS === '') {
          setInputParrotS();
      }
    };

       const handleAcceptParrot = (id) => {
            setLoading(true);
            let forSend = { port_status: inputParrotS, port_command: inputParrotT }
            POSTConnPYV(token, forSend).then((e) => {
                setLoading(false);
                setShowParrot(false);
                setInputParrotS();
                setInputParrotT();

            })
        }

        const handleChangeT = (e) => {
            const inputValue = e.target.value;
            
            // Разрешаем пустую строку для UX
            if (inputValue === '') {
                setInputParrotT('');
              return;
            }
             setInputParrotT(e.target.value.replace(/[^a-zA-Z0-9.\-]/g, ''));
        };

        const handleChangeS = (e) => {
          const inputValue = e.target.value;
          
          // Разрешаем пустую строку для UX
          if (inputValue === '') {
              setInputParrotS('');
            return;
          }
           setInputParrotS(e.target.value.replace(/[^a-zA-Z0-9.\-]/g, ''));
      };

    if (!arrTable[0]?.value)
        return <MainArea loading />;

    return (
        <>
            <MainArea>
                    <div className={classCard} style={styleCard}>
                        <MainAreaHeader caption="ПУВ-СРК" />
                        <div className="container-fluid px-3 py-4 dashboard">
                        <div className="row g-3">  
                              <div className="cont-table">
                                                    <DataTable removableSort emptyMessage="Нет данных" value={arrTable} tableStyle={{ minWidth: '50rem' }}>
                                                        {/* <Column field="code" sortable header="Временная метка"></Column> */}
                                                        <Column field="name" sortable header="Параметр"></Column>
                                                        <Column field="value" sortable header="Значение"></Column>
                                                    </DataTable>
                                                </div>
                                                </div></div>
                                {services.map((e, i) => {
                                return (
                                    <div key={i} className="container-fluid padding-f-d dashboard">

                                        <fieldset className="mfuncbutton-fieldset padding-f">
                                            <div className="cont-mfuncbuttons">
                                                {
                                                    <div className='cont-mfuncbutton'><button type="button" className="btn btn-primary btn-sm btn-our mfuncbutton" onClick={() => {setShowParrot(true); setInputParrotT(arrTable[0]?.value); setInputParrotS(arrTable[1]?.value)}} >Изменить параметры</button></div>
                                                }
                                            </div>
                                         </fieldset>
                                        <Modal show={showParrot} className={`modal-parrot`} onHide={handleCloseParrot}
                                            // onExited={handleExited} centered backdrop="static" keyboard={!(loading || !loaded)}>
                                            onExited={() => setShowParrot(false)} centered backdrop="static">
                                            <Modal.Header closeButton>
                                                <Modal.Title className="h6">Изменить параметры</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body className="pb1-1">
                                        {/* <fieldset disabled={loading || !loaded || !params.show}> */}
                                                <fieldset className="mfuncbutton-fieldset mfuncbutton-fieldset-flex" >
                                                  <div>Телекодовый</div>
                                                    <input onBlur={handleBlur} value={inputParrotT} className='input-parrot' onChange={handleChangeT}></input>
                                                    <div>Статусный</div>
                                                    <input onBlur={handleBlur} value={inputParrotS} className='input-parrot' onChange={handleChangeS}></input>
                                                </fieldset>
                                            </Modal.Body>
                                            <Modal.Footer>
                                                {/* <fieldset disabled={loading || !loaded || !params.show}> */}
                                                <fieldset>
                                                    <div className='cont-btn'>
                                                        <button type="button" className="btn btn-secondary btn-sm btn-our ms-2" onClick={handleCloseParrot}>Закрыть</button>
                                                        <button type="button" className="btn btn-secondary btn-sm btn-our ms-2" onClick={() => handleAcceptParrot(i)}>Применить</button>
                                                    </div>
                                                </fieldset>
                                            </Modal.Footer>
                                        </Modal >
                                    </div>
                                )
                            })}
                    </div>
  
                {/* </MainAreaBody> */}
            </MainArea >
        </>
    );
}



export default PUVSRKStations;
